import React from 'react';
import { ArrowLeft, Eye } from 'lucide-react';
import { Button } from '../ui/Button';
interface ViewingLearnerBannerProps {
  learnerName: string;
  portalName: string;
  onReturn: () => void;
}
export function ViewingLearnerBanner({
  learnerName,
  portalName,
  onReturn
}: ViewingLearnerBannerProps) {
  return <div className="bg-indigo-600 text-white px-4 py-3 shadow-md relative z-50" data-id="element-5133">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3" data-id="element-5134">
        <div className="flex items-center gap-2" data-id="element-5135">
          <Eye className="w-5 h-5 text-indigo-200" data-id="element-5136" />
          <span className="font-medium" data-id="element-5137">
            Je bekijkt nu het dashboard van{' '}
            <strong className="font-black" data-id="element-5138">{learnerName}</strong>
          </span>
        </div>
        <Button variant="secondary" size="sm" onClick={onReturn} className="bg-white text-indigo-700 hover:bg-indigo-50 border-none whitespace-nowrap" data-id="element-5139">
          <ArrowLeft className="w-4 h-4 mr-2" data-id="element-5140" />
          Terug naar {portalName}
        </Button>
      </div>
    </div>;
}